import { Ref } from 'react';
import { Checkbox as PrimeCheckbox, CheckboxProps as PrimeCheckboxProps } from 'primereact/checkbox';
import { Control, Controller } from 'react-hook-form';
import cn from 'classnames';

import 'primereact/checkbox/checkbox.min.css';
import classes from './checkbox.module.scss';

export type CheckboxProps = PrimeCheckboxProps & {
  label?: string,
  rootClassName?: string,
  checkboxClassName?: string,
  labelClassName?: string,
  wrapperRootClassName?: string;
  fieldId: string,
  error?: string;
  name: string;
  control?: Control<any>;
  inputRef?: Ref<HTMLInputElement>,
};

const SimpleCheckbox = (props: CheckboxProps) =>
  <div className={cn(classes.root, props.rootClassName)}>
  <div className={cn(classes.wrapperRoot, props.wrapperRootClassName)}>
    <PrimeCheckbox inputId={props.fieldId} checked={props.value} {...props}   className={cn(classes.checkbox, props.checkboxClassName)} />
    <label htmlFor={props.fieldId} className={cn(classes.label, props.labelClassName)}>{props.label}</label>
  </div>
    <small className={classes.error}>{props.error}</small>
  </div>

export const Checkbox = (props: CheckboxProps) => (
  !props.control
    ? <SimpleCheckbox {...props} />
    : <Controller
        render={({ field: { ref, ...field }}) => <SimpleCheckbox inputRef={ref} {...field} {...props} /> }
        name={props.name}
        control={props.control}
      />
);
